import { ATTENDANCE_MANAGEMENT_ES_MX } from "../attendance-management/translations/attendance-management-es-mx";
import { BarsAndSectorsTranslations } from "./bars-and-sectors-pt-br";

export const BARS_AND_SECTORS_ES_MX: BarsAndSectorsTranslations = {
	title: "Bares",
	barsAndSectors: "Bares y Sectores",
	description: "Crea y administra ambientes y mesas de tu establecimiento.",
	bars: "Bares",
	sectors: "Sectores",
	generalSettings: "Configuraciones Generales",
	printByTableSettings: "Configurar impresión de mesas",
	attendanceManagement: ATTENDANCE_MANAGEMENT_ES_MX,
	editSector: "Editar sector",
	createSector: "Crear sector",
	createNewSector: "Crear nuevo sector",
	newSector: "Nuevo sector",
	searchPlaceholderSector: "Buscar por nombre de sector o bar",
	searchPlaceholderAccess: "Buscar por nombre de acceso",
	sectorName: "Nombre del sector",
	sectorBars: "Bares del sector",
	accessControl: "Control de acceso",
	createAccess: "Crear acceso",
	newAccess: "Nuevo acceso",
	editAccess: "Editar acceso",
	createNewAccess: "Crear nuevo acceso",
	accessName: "Nombre del acceso",
	initialDate: "Inicio",
	endDate: "Fin",
	range: "Rango de ZigCards",
	zigCardsId: "ID ZigCard",
	downloadModel: "Descargar el modelo",
	selectFile: "Seleccionar un archivo",
	selectFileDescription: "Tipo de archivo [.xlsx, .xls] hasta [500 mb].",
	removeFile: "Remover archivo",
	createAccessSuccess: "Acceso creado con éxito",
	editAccessSuccess: "Acceso editado con éxito",
	name: "Nombre",
	initialDateHour: "Fecha y hora inicial",
	endDateHour: "Fecha y hora final",
	deleteSector: "Excluir sector",
	deleteSectorSubtitle: "¿Está seguro de que desea excluir el sector?",
	deleteSectorSuccess: "Sector excluído con éxito",
	editSectorSuccess: "Sector editado con éxito",
	createSectorSuccess: "Sector creado con éxito",
	deleteAccessPolicy: "Excluir acceso",
	deleteAccessPolicySubtitle: "¿Está seguro de que desea excluir el acceso?",
	deleteAccessPolicySuccess: "Acceso excluído con éxito",
	editAccessPolicySuccess: "Acceso editado con éxito",
	createAccessPolicySuccess: "Acceso creado con éxito",
	importAccessPolicyTagsSuccess: "Ids importadas con éxito",
	accesses: "Accesos",
	sectorAccesses: "Accesos del sector",
	modelFileName: "modelo-de-hoja-de-cálculo",
	noSectors: "No hay sectores registrados",
	tagIdsError: "Agregue al menos un ID de ZigCard",
	onlySpacesError: "El campo no puede contener solo espacios",
	seeZigCards: "Ver ZigCards",
};
